import { render, staticRenderFns } from "./consumption.vue?vue&type=template&id=f3085b0c&scoped=true"
import script from "./consumption.vue?vue&type=script&lang=js"
export * from "./consumption.vue?vue&type=script&lang=js"
import style0 from "./consumption.vue?vue&type=style&index=0&id=f3085b0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3085b0c",
  null
  
)

export default component.exports